// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/instrument.proto (package squareup.common.instrument, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file squareup/common/instrument.proto.
 */
export const file_squareup_common_instrument: GenFile = /*@__PURE__*/
  fileDesc("CiBzcXVhcmV1cC9jb21tb24vaW5zdHJ1bWVudC5wcm90bxIac3F1YXJldXAuY29tbW9uLmluc3RydW1lbnQq+gMKDkluc3RydW1lbnRUeXBlEgsKB1VOS05PV04QARIICgRWSVNBEAISDwoLTUFTVEVSX0NBUkQQAxIUChBBTUVSSUNBTl9FWFBSRVNTEAQSDAoIRElTQ09WRVIQBRITCg9ESVNDT1ZFUl9ESU5FUlMQBhIHCgNKQ0IQBxILCgdCQUxBTkNFEAgSDQoJVU5JT05fUEFZEAkSFwoTU1FVQVJFX0dJRlRfQ0FSRF9WMhAKEgsKB0lOVEVSQUMQCxIXChNTUVVBUkVfQ0FQSVRBTF9DQVJEEAwSCgoGRUZUUE9TEA0SCgoGRkVMSUNBEA4SCgoGQUxJUEFZEA8SDAoIQ0FTSF9BUFAQEBIHCgNFQlQQERIKCgZQQVlQQVkQEhIMCghBRlRFUlBBWRATEhoKFlNRVUFSRV9BQ0NPVU5UX0JBTEFOQ0UQFBIKCgZBVV9QQVkQFRIKCgZNRVJQQVkQFhIPCgtSQUtVVEVOX1BBWRAXEgsKB0RfQkFSQUkQGBIOCgpXRUNIQVRfUEFZEBkSEAoMU1RPUkVEX1ZBTFVFEBoSCwoHUVVJQ1BBWRAbEgYKAklEEBwSFQoRVFJBTlNQT1JUQVRJT05fSUMQHRISCgpDQVNIX0xPQ0FMEB4aAggBEg4KCkxPQ0FMX0NBU0gQHxIKCgZDQVJORVQQIEInCiVjb20uc3F1YXJldXAucHJvdG9zLmNvbW1vbi5pbnN0cnVtZW50");

/**
 * *
 * A form of payment that Square accepts for money transfer.
 *
 * @generated from enum squareup.common.instrument.InstrumentType
 */
export enum InstrumentType {
  /**
   * @generated from enum value: UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * @generated from enum value: VISA = 2;
   */
  VISA = 2,

  /**
   * @generated from enum value: MASTER_CARD = 3;
   */
  MASTER_CARD = 3,

  /**
   * @generated from enum value: AMERICAN_EXPRESS = 4;
   */
  AMERICAN_EXPRESS = 4,

  /**
   * @generated from enum value: DISCOVER = 5;
   */
  DISCOVER = 5,

  /**
   * @generated from enum value: DISCOVER_DINERS = 6;
   */
  DISCOVER_DINERS = 6,

  /**
   * @generated from enum value: JCB = 7;
   */
  JCB = 7,

  /**
   * @generated from enum value: BALANCE = 8;
   */
  BALANCE = 8,

  /**
   * @generated from enum value: UNION_PAY = 9;
   */
  UNION_PAY = 9,

  /**
   * @generated from enum value: SQUARE_GIFT_CARD_V2 = 10;
   */
  SQUARE_GIFT_CARD_V2 = 10,

  /**
   * @generated from enum value: INTERAC = 11;
   */
  INTERAC = 11,

  /**
   * @generated from enum value: SQUARE_CAPITAL_CARD = 12;
   */
  SQUARE_CAPITAL_CARD = 12,

  /**
   * @generated from enum value: EFTPOS = 13;
   */
  EFTPOS = 13,

  /**
   * @generated from enum value: FELICA = 14;
   */
  FELICA = 14,

  /**
   * @generated from enum value: ALIPAY = 15;
   */
  ALIPAY = 15,

  /**
   * @generated from enum value: CASH_APP = 16;
   */
  CASH_APP = 16,

  /**
   * @generated from enum value: EBT = 17;
   */
  EBT = 17,

  /**
   * @generated from enum value: PAYPAY = 18;
   */
  PAYPAY = 18,

  /**
   * @generated from enum value: AFTERPAY = 19;
   */
  AFTERPAY = 19,

  /**
   * @generated from enum value: SQUARE_ACCOUNT_BALANCE = 20;
   */
  SQUARE_ACCOUNT_BALANCE = 20,

  /**
   * @generated from enum value: AU_PAY = 21;
   */
  AU_PAY = 21,

  /**
   * @generated from enum value: MERPAY = 22;
   */
  MERPAY = 22,

  /**
   * @generated from enum value: RAKUTEN_PAY = 23;
   */
  RAKUTEN_PAY = 23,

  /**
   * @generated from enum value: D_BARAI = 24;
   */
  D_BARAI = 24,

  /**
   * @generated from enum value: WECHAT_PAY = 25;
   */
  WECHAT_PAY = 25,

  /**
   * @generated from enum value: STORED_VALUE = 26;
   */
  STORED_VALUE = 26,

  /**
   * @generated from enum value: QUICPAY = 27;
   */
  QUICPAY = 27,

  /**
   * @generated from enum value: ID = 28;
   */
  ID = 28,

  /**
   * @generated from enum value: TRANSPORTATION_IC = 29;
   */
  TRANSPORTATION_IC = 29,

  /**
   * CASH_LOCAL was a misnaming of the Local Cash payment method; new code should use LOCAL_CASH.
   *
   * @generated from enum value: CASH_LOCAL = 30 [deprecated = true];
   * @deprecated
   */
  CASH_LOCAL = 30,

  /**
   * @generated from enum value: LOCAL_CASH = 31;
   */
  LOCAL_CASH = 31,

  /**
   * @generated from enum value: CARNET = 32;
   */
  CARNET = 32,
}

/**
 * Describes the enum squareup.common.instrument.InstrumentType.
 */
export const InstrumentTypeSchema: GenEnum<InstrumentType> = /*@__PURE__*/
  enumDesc(file_squareup_common_instrument, 0);

